module.exports = __webpack_public_path__ + "static/media/home-img-de.6c4bcda6.svg";